import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getTypesRequest: ["children_id"],
  getTypesSuccess: ["listTypes"],
  getTypesFailure: null,
});

export const GetTypesTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  payload: null,
  success: null,
  error: null,
  children_id: null,
});

export const GetTypesSelectors = {
  getData: (state: any) => state.getTypes.data,
  isFetching: (state: any) => state.getTypes.fetching,
  isSuccess: (state: any) => state.getTypes.success,
  hasError: (state: any) => state.getTypes.error,
};

export const request = (state: any, { children_id }: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    children_id,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { listTypes } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    listTypes,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_TYPES_REQUEST]: request,
  [Types.GET_TYPES_SUCCESS]: success,
  [Types.GET_TYPES_FAILURE]: failure,
});
